// @flow
/* eslint-env browser */

import '@webcomponents/custom-elements';

import debug from '../../shared/debug';
import { LIB_VERSION } from '../../version';
import { defineCustomElement } from '../../define-custom-element';
import { isInViewport } from '../common/is-in-viewport';

import { renderCarousel } from './carousel';
import SlotMapping from './slot-mapping';
import { CoreService } from './core-service';
import { cobrandCallForAd } from './usat-wrapper-start';

window.localStorage.setItem('display-version', `games.usatoday.com/${LIB_VERSION}`);

const Mapping = window.innerWidth <= 768 ? SlotMapping.MOBILE : SlotMapping.DESKTOP;

const shouldRenderCarousel = (id: string) => (id === 'ark_display_r1') && (document.location.hostname.includes('puzzles.usatoday.com'));

export class DisplayAdComponent extends HTMLElement {
    log = debug('arkadium-ads:display:component');

    gtag: any;

    slot: any;

    size: number[][];

    unit: string;

    adId: string;

    slot: any;

    normalId: string;

    coreService = CoreService.getInstance();

    isRendered = false;

    error: Error;

    isDetached: boolean = false;

    targeting: any = {};

    connectedCallback() {
        this.log('connectedCallback: started');
        this.normalId = (this.dataset.id || '').replace(/-/g, '_');
        this.size = this.getSize();
        this.style.display = 'block';
        // this.style.width = `${Math.max(...this.size.map(s => s[0]))}px`;
        this.style.height = `${Math.max(...this.size.map(s => s[1]))}px`;
        const normalId: any = this.dataset.id && this.dataset.id.replace(/-/g, '_');
        const { id, unit, count } = Mapping[normalId] || {};
        if (!id) {
            this.log(`connectedCallback: ID is not defined - ${normalId}`);
            return;
        }
        if (document.location.pathname === '/') {
            this.targeting = !isNaN(count) ? { adcount: count } : {}; // eslint-disable-line
        }
        this.unit = unit;
        this.adId = id;
        this.coreService.queueAdShow(this);
        if (shouldRenderCarousel(this.normalId)) {
            renderCarousel((this.parentElement && this.parentElement.parentElement) || this);
        }
        this.log('connectedCallback: finished');
    }

    render() {
        this.log('render: started');
        if (this.isDetached) {
            this.log('render: not rendering because isDetached = true');
            return;
        }
        // const [width, height] = this.size[0];
        this.insertAdjacentHTML(
            'beforeend',
            `<div id='${this.adId}' ${this.normalId === 'ark_display_t1' ? 'align="center"' : ''}></div>`,
        );
        cobrandCallForAd(this.adId, this.unit, this.size, this.targeting, slotRef => this.slot = slotRef);
        this.isRendered = true;
        this.log('render: finished');
    }

    refresh() {

    }

    getSize() {
        const size = this.getAttribute('dimensions');
        if (!size) {
            this.log('getSize: "dimensions" is not specified');
            return [];
        }
        try {
            return JSON.parse(size);
        } catch (e) {
            this.log(e);
            return [];
        }
    }

    isViewable() {
        return isInViewport(this);
    }

    disconnectedCallback() {
        this.isDetached = true;
        this.coreService.removeAd(this);
        this.log(`disconnectedCallback: id = ${this.dataset.id}, adId = ${this.adId}`);
    }
}

defineCustomElement(DisplayAdComponent);
